import { Injectable } from '@angular/core'
import { HttpService, IExportFileResponse } from '@lla-platform/core/core-data-access'
import { DateService } from '@lla-platform/core/core-util'
import { Observable } from 'rxjs'
import { IAddonsRequest, IAddonsResponse } from '../interfaces/addons.interface'
import { ADDONS_API_URL } from './addons-api-routes'

@Injectable({
  providedIn: 'root'
})
export class AddonsService {
  constructor(
    private http: HttpService,
    private dateService: DateService
  ) {}

  getAddonsSummary(payload: IAddonsRequest): Observable<IAddonsResponse> {
    const { from, to } = payload
    return this.http.post(ADDONS_API_URL.addonsSummary, {
      ...payload,
      from: this.dateService.momentToDateString(from),
      to: this.dateService.momentToDateString(to)
    })
  }

  exportAddonsSummary(payload: IAddonsRequest): Observable<IExportFileResponse> {
    const { from, to } = payload
    return this.http.post(ADDONS_API_URL.exportAddonsSummary, {
      ...payload,
      from: this.dateService.momentToDateString(from),
      to: this.dateService.momentToDateString(to)
    })
  }
}
